import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectOffer } from '../../../selectors/selectOffer';
import { selectPriceHistoryChartData } from '../../../selectors/selectPriceHistoryChartData';
import { selectAgent } from '../../../selectors/selectAgent';
import { selectDealType } from '../../../selectors/selectDealtype';
import { selectCostEstimation } from '../../../selectors/selectCostEstimation';
import { selectOfferType } from '../../../selectors/selectOfferType';

export const useCostEstimateFeatureData = () => {
  const offer = useSelector(selectOffer);
  const offerType = useSelector(selectOfferType);
  const priceHistoryChartData = useSelector(selectPriceHistoryChartData);
  const agent = useSelector(selectAgent);
  const dealType = useSelector(selectDealType);
  const costEstimate = useSelector(selectCostEstimation);

  return React.useMemo(
    () => ({
      offer,
      offerType,
      priceHistoryChartData,
      agent,
      dealType,
      costEstimate,
    }),
    [offer, offerType, priceHistoryChartData, agent, dealType, costEstimate],
  );
};
